import { Fragment, createElement } from 'react';
import { embeddedBundle } from './locale/embeddedI18N';
import { BusyStateIndicator } from '@sas/nova-commons/components/BusyStateIndicator';
import { useDesignTokens } from '@sas/nova-commons/theme';
// TODO: move this into a SASReport folder
export const Loading = () => {
    const dt = useDesignTokens();
    return (createElement(Fragment, null,
        createElement("span", { style: { visibility: 'hidden', position: 'absolute', fontFamily: '"AvenirNext"' } }, "Mg"),
        createElement("div", { style: {
                display: 'flex',
                flexShrink: 1,
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'center',
                backgroundColor: dt.enableNovaTokens
                    ? dt.backgroundsNova.panes.bg
                    : dt.backgrounds.panes.bg,
            } },
            createElement(BusyStateIndicator, { active: true, text: embeddedBundle['loading.msg'](), delay: 0 }))));
};
//# sourceMappingURL=Loading.js.map